module.exports = __webpack_public_path__ + "img/kabum-thumb.26c04dd5.png";